import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { portalApi } from '../../utils/portalApi';

export default function EmployeeDashboardPage() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    portalApi.listAdminArticles().then((data) => setArticles(data.articles || [])).catch(() => setArticles([]));
  }, []);

  const stats = useMemo(() => {
    const published = articles.filter((a) => a.status === 'published').length;
    const draft = articles.filter((a) => a.status === 'draft').length;
    return { total: articles.length, published, draft };
  }, [articles]);

  return (
    <section>
      <h1 className="text-2xl font-semibold text-slate-900">Dashboard</h1>
      <p className="mt-1 text-slate-600">Manage Insights content for the public website.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        <StatCard label="Total articles" value={stats.total} />
        <StatCard label="Published" value={stats.published} />
        <StatCard label="Drafts" value={stats.draft} />
      </div>
      <div className="mt-6 rounded-2xl bg-white p-5 ring-1 ring-slate-200">
        <h2 className="text-lg font-semibold text-slate-900">Quick actions</h2>
        <div className="mt-4 flex flex-wrap gap-3">
          <Link to="/articles/new" className="rounded-lg bg-cam-blue px-4 py-2 text-white hover:bg-cam-blue/90">Create New Article</Link>
          <Link to="/articles" className="rounded-lg border border-slate-300 px-4 py-2 text-slate-700 hover:bg-slate-50">View all articles</Link>
        </div>
      </div>
    </section>
  );
}

function StatCard({ label, value }) {
  return (
    <div className="rounded-2xl bg-white p-5 ring-1 ring-slate-200">
      <p className="text-sm text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-slate-900">{value}</p>
    </div>
  );
}
